<template>
    <div class="calendar__toggles">
        <label class="calendar__toggle toggle" v-if="isShowClinic">
            <input v-model="type" :value="clinicType" class="toggle__input screen-reader" type="radio" name="booking-types" checked="">
            <span class="toggle__label">
                    <span class="toggle__text">Приём в клинике</span>
                </span>
        </label>
        <label class="calendar__toggle toggle" v-if="isShowOnline">
            <input v-model="type" :value="onlineType" class="toggle__input screen-reader" type="radio" name="booking-types">
            <span class="toggle__label">
                    <span class="toggle__text">Онлайн приём</span>
                </span>
        </label>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';
    import dayjs from "dayjs";

    export default {
        name: "CalendarToogle",
        data() {
            return {
                clinicType: window.laravel.appointmentsTypes.clinic,
                onlineType: window.laravel.appointmentsTypes.online,
                actualTypes: window.laravel.actualTypes,
                isShowClinic: false,
                isShowOnline: false,
            }
        },
        mounted() {
            let filterCheckbox = null;

            if (document.referrer.indexOf('doctors') + 1 || document.referrer.indexOf('clinics') + 1) {
                filterCheckbox = JSON.parse(sessionStorage.getItem('filterCheckbox'));
            }

            this.isShowClinic = !!(this.access === 'doctor' || (this.actualTypes['clinic'] || (filterCheckbox && filterCheckbox['appointmentTypes']['elements'][0]['checked'] && !filterCheckbox['appointmentTypes']['elements'][1]['checked'])));
            this.isShowOnline = !!(this.access === 'doctor' || (this.actualTypes['online'] || (filterCheckbox && filterCheckbox['appointmentTypes']['elements'][1]['checked'] && !filterCheckbox['appointmentTypes']['elements'][0]['checked'])));

            if (this.actualTypes['firstDate']) {
                if(this.access === 'doctor'){
                    this.setStartDate(dayjs().startOf('week'))
                } else {
                    this.setStartDate(dayjs(this.actualTypes['firstDate']));
                }
            }

            if (this.actualTypes['firstType'] === this.clinicType && this.isShowClinic && !this.isShowOnline) {
                this.setAppointmentsType(this.clinicType);
            } else if (!this.isShowClinic && this.isShowOnline) {
                this.setAppointmentsType(this.onlineType);
            } else if (this.actualTypes['firstType'] === this.clinicType) {
                this.setAppointmentsType(this.clinicType);
            } else {
                this.setAppointmentsType(this.onlineType);
            }

            if (this.access !== 'doctor') {
                if (filterCheckbox && filterCheckbox['appointmentTypes']) {
                    if (filterCheckbox['appointmentTypes']['elements'][0]['checked'] !== filterCheckbox['appointmentTypes']['elements'][1]['checked']) {
                        filterCheckbox['appointmentTypes']['elements'].forEach((element, key) => {
                            if (element.checked) this.setAppointmentsType(element.id);
                        });
                    } else if (this.actualTypes['clinic'] !== this.actualTypes['online']) {
                        this.actualTypes['clinic'] ? this.setAppointmentsType(this.clinicType) : this.setAppointmentsType(this.onlineType);
                    }
                }
            }
        },
        computed: {
            ...mapState([
                'access',
                'disabledToggles',
                'appointmentsType',
            ]),
            type: {
                get() {
                    return this.appointmentsType
                },
                set (value) {
                    this.setAppointmentsType(value);
                },
            }
        },
        watch: {
            type() {
                if (this.access !== 'doctor') {
                    this.generateCells();
                }
            }
        },
        methods: {
            ...mapMutations([
                'setAppointmentsType',
                'setStartDate',
            ]),
            ...mapActions([
                'generateCells',
            ]),
        }
    }
</script>
